/**
 * Language Store Module
 *
 * Stores the current language for the application, extracted from URL parameters.
 * Used to initialize Weglot with the correct language.
 */
const state = {
  currentLanguage: 'en',
  availableLanguages: ['en', 'es'],
};

const mutations = {
  /* eslint-disable no-param-reassign */
  setLanguage(languageState, language) {
    const validLang = languageState.availableLanguages.includes(language)
      ? language
      : 'en';
    languageState.currentLanguage = validLang;
  },
  /* eslint-enable no-param-reassign */
};

const getters = {
  getCurrentLanguage: languageState => languageState.currentLanguage,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
